// @flow
import type {Action} from '../../../state/types'

export type SetPlaceListPayload = {
  placeList: ServiceProvider[],
}

const id = 'place/SET_PLACE_LIST'

export const setPlaceList = (placeList: ServiceProvider[]): Action<SetPlaceListPayload> => ({
  type: id,
  payload: {
    placeList,
  }
})

setPlaceList.id = id
